var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{key:_vm.id,attrs:{"dismissible":"","show":!!_vm.value,"variant":"danger"}},[_vm._v(_vm._s(_vm.value))])
}
var staticRenderFns = []

export { render, staticRenderFns }